<span *ngIf="isValidValue" class="badge badge-icon" [ngClass]="badgeClass">
  <i [ngClass]="iconClass" class="f-i"></i>
</span>
